export const icons = {
  vooshLogoSquare: require("./vooshLogoSquare.png"),
  login_error: require("./login_error.webp"),
};
